import { z } from "zod";

/** Existing History filters, carried by Live now only for the return link. */
export const callHistorySearch = z.object({
  user: z.string().optional().catch(undefined),
  from: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
  to: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
  direction: z.enum(["inbound", "outbound"]).optional().catch(undefined),
  disposition: z
    .string()
    .regex(/^[a-z_]{3,20}$|^[0-9a-f-]{36}$/)
    .optional()
    .catch(undefined),
  dropped: z.boolean().optional().catch(undefined),
});

export type CallHistorySearch = z.infer<typeof callHistorySearch>;
